import { Box } from "@mui/system"
import React from "react"

const StandardPaperVMargin = ({children}: {children: React.ReactNode}) => {
    return <Box sx={{padding: "0.5rem 0"}}>
        {children}
    </Box>
}
export default StandardPaperVMargin;